import Api from '../../../../../../../shared/Api';
import { ImageModel, ImageUploadResponse } from '../../../shared/types';
import { CustomerOrSupportImage } from "../../uneditedImages/view/UploadUneditedImages";

export class EditedImagesApi {
    static getImages(orderId: number): Promise<ImageModel> {
        return new Api().get(`/views/digital-styling-upload/${orderId}/edited`);
    }

    static deleteSingleImage(imageId: number): Promise<void> {
        return new Api().delete(`/views/digital-styling-upload/${imageId}`);
    }

    static deleteMultipleImages(images: CustomerOrSupportImage[]): Promise<void> {
        return new Api().post(`/views/digital-styling-upload/delete-multiple`, {
            images
        });
    }

    static deleteFailedUploadImage(imageId: number): Promise<any> {
        return new Api().delete(`/views/digital-styling-upload/meta/${imageId}`);
    }

    static setImageInProgress(imageData: ImageUploadResponse): Promise<any> {
        return new Api().post(`/views/digital-styling-upload/edited/in-progress`, { ...imageData });
    }

    static downloadImages(orderId: number): Promise<Response> {
        return new Api().get(`/views/digital-styling-upload/edited/download/${orderId}`);
    }

    static deliverImages(orderId: number): Promise<any> {
        return new Api().post(`/views/digital-styling-upload/edited/deliver/${orderId}`, {});
    }
}
